import { Component, input } from '@angular/core';

@Component({
  selector: 'shared-core-badge',
  standalone: true,
  imports: [],
  templateUrl: './badge.component.html',
})
export class BadgeComponent {
  readonly message = input.required<string>();
}
